<template>
<div class="chapter">
<div class="inner_page">
<a id="page_x"></a>
<h2 class="fmtitle"><span class="bold">Maps</span></h2>
<p class="map"><a href="#/xhtml/09_Chapter01#pg3map1">Organisation of the Kriegsmarine, Spring 1940</a></p>
<p class="map"><a href="#/xhtml/11_Chapter03#pg32map1">Trade routes to Germany</a></p>
<p class="map"><a href="#/xhtml/11_Chapter03#pg47map1">The Winter War, 1939–1940</a></p>
<p class="map"><span href="#/xhtml/14_Chapter06#pg110map1" title="Link target outside of Sample">Group V, 7 April</span></p>
<p class="map"><span href="#/xhtml/15_Chapter07#pg118map1" title="Link target outside of Sample">1. R-Boat Flotilla, 7 and 8 April</span></p>
<p class="map"><span href="#/xhtml/15_Chapter07#pg123map1" title="Link target outside of Sample">Group V, 8 April</span></p>
<p class="map"><span href="#/xhtml/15_Chapter07#pg128map1" title="Link target outside of Sample">The Skagerrak, 8 April</span></p>
<p class="map"><span href="#/xhtml/16_Chapter08#pg136map1" title="Link target outside of Sample">Operation <em class="italic">Weserübung</em></span></p>
<p class="map"><span href="#/xhtml/16_Chapter08#pg159map1" title="Link target outside of Sample">German mines in the Skagerrak, April 1940</span></p>
<p class="map"><span href="#/xhtml/18_Chapter10#pg175map1" title="Link target outside of Sample">Oslofjord, Group V</span></p>
<p class="map"><span href="#/xhtml/18_Chapter10#pg184map1" title="Link target outside of Sample">Outer Oslofjord, Night of 8–9 April</span></p>
<p class="map"><span href="#/xhtml/19_Chapter11#pg191map1" title="Link target outside of Sample">The Drøbak Narrows, 9 April – Morning</span></p>
<p class="map"><span href="#/xhtml/19_Chapter11#pg196map1" title="Link target outside of Sample">Oscarsborg Fortress</span></p>
<p class="map"><span href="#/xhtml/20_Chapter12#pg247map1" title="Link target outside of Sample">The Drøbak Narrows, 9 April – Afternoon</span></p>
<p class="map"><span href="#/xhtml/21_Chapter13#pg257map1" title="Link target outside of Sample">Horten, 9 April</span></p>
<p class="map"><span href="#/xhtml/21_Chapter13#pg270map1" title="Link target outside of Sample">Rauøy, 9 April</span></p>
<p class="map"><span href="#/xhtml/22_Chapter14#pg307map1" title="Link target outside of Sample">German advances out of Oslo</span></p>
<p class="map"><span href="#/xhtml/22_Chapter14#pg310map1" title="Link target outside of Sample">Operation <em class="italic">Weserübung Süd</em> – Denmark 9 April</span></p>
<p class="map"><span href="#/xhtml/22_Chapter14#pg316map1" title="Link target outside of Sample">British Submarines in the Skagerrak and Kattegat, April 1940</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Maps.vue?199b81bc